import { EmployerVerificationData, ReferenceVerificationData } from './ApplicantDataResponses/ApplicantDataResponses';
import { ApplicantDocument, EndUserCertification } from './screeningInvite';

export class ScreeningDraft {
    constructor(){
        this.employmentData = new EmployerVerificationData();
        this.referenceData = new ReferenceVerificationData();
        this.docs = new Array<ApplicantDocument>();
        this.certification = new EndUserCertification();
    }
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
    ssn: string;
    dob: Date;
    clientId: number;
    clientLocationId: number;
    clientLocationName: string;
    email: string;
    noMiddleNameCertified: boolean;
    cellPhone: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    county : string;
    monthlyIncome: number;
    rentAmount: number;
    sendConsumerCopy: boolean;
    userId : number;
    requestingUserId: number;
    searchPackageId: number;
    convertedToScreening: boolean;
    hasDocs: boolean;
    startingUserName : string;
    posReportCost : number;
    draftBasePrice : number;
    lastCompletedPhase : number;
    phaseOverride : number;
    archived : boolean;
    createdDate : Date;
    includeIncomeVer : boolean;
    // Additional Data
    alternativeScoringModelId: number;
    employmentData: EmployerVerificationData;
    referenceData: ReferenceVerificationData;
    docs: ApplicantDocument[];
    certification : EndUserCertification;
    hasVerificationsInPackage: boolean;
    paymentId : number;
    formatPhoneNumber() {
        if(this.cellPhone){
            var cleaned = ('' + this.cellPhone).replace(/\D/g, '')
            var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
            if (match) {
              var intlCode = (match[1] ? '+1 ' : '')
              this.cellPhone = [match[1],match[2], match[3],match[4]].join('')
            }
          }
    }
}